const CertificationSection = () => {
  return (
    <section id="aprobacion" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=premium%20La%20Roche-Posay%20skincare%20products%20collection%20beautifully%20arranged%20on%20white%20marble%20with%20soft%20natural%20light%2C%20luxury%20imported%20dermatological%20cosmetics%20with%20certificates%20and%20quality%20seals%2C%20professional%20product%20photography%20with%20clean%20minimalist%20background%20and%20warm%20tones&width=700&height=800&seq=cert2cr&orientation=portrait"
              alt="Productos certificados distribuidores autorizados"
              className="w-full h-[600px] object-cover rounded-[40px] shadow-lg"
            />
          </div>

          <div>
            <div className="inline-block px-6 py-2 bg-[#FAF8F5] rounded-full mb-6">
              <span className="text-gray-700 text-sm font-light">Calidad Garantizada</span>
            </div>
            <h2 className="font-['Playfair_Display'] text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              Productos con Respaldo Científico Comprobado
            </h2>
            <div className="space-y-5 mb-10">
              <p className="text-gray-600 text-base font-light leading-relaxed">
                Somos distribuidores autorizados de las marcas más reconocidas del mundo. Algunos cuentan con <strong className="font-semibold text-gray-900">aprobación dermatológica</strong>, otros con <strong className="font-semibold text-gray-900">respaldo clínico</strong> — en todos los casos, son productos con eficacia y seguridad comprobada.
              </p>
              <p className="text-gray-600 text-base font-light leading-relaxed">
                La Roche-Posay, nuestra marca principal, es recomendada por más de 90,000 dermatólogos en el mundo y sus fórmulas son desarrolladas con agua termal de propiedades únicas.
              </p>
              <p className="text-gray-600 text-base font-light leading-relaxed">
                Todos los productos que distribuimos en Costa Rica son <strong className="font-semibold text-gray-900">100% originales, adquiridos directamente de distribuidores autorizados</strong>, sin intermediarios que comprometan su calidad o autenticidad.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-10">
              <div className="flex flex-col items-start p-5 bg-[#FAF8F5] rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/15 rounded-full mb-3">
                  <i className="ri-verified-badge-line text-[#D4AF37] text-lg"></i>
                </div>
                <h4 className="text-gray-900 font-semibold text-sm mb-1 leading-snug">Aprobado Dermatológicamente</h4>
                <p className="text-gray-500 text-xs font-light leading-relaxed">En productos seleccionados</p>
              </div>
              <div className="flex flex-col items-start p-5 bg-[#FAF8F5] rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/15 rounded-full mb-3">
                  <i className="ri-microscope-line text-[#D4AF37] text-lg"></i>
                </div>
                <h4 className="text-gray-900 font-semibold text-sm mb-1 leading-snug">Testado Clínicamente</h4>
                <p className="text-gray-500 text-xs font-light leading-relaxed">Estudios científicos rigurosos</p>
              </div>
              <div className="flex flex-col items-start p-5 bg-[#FAF8F5] rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/15 rounded-full mb-3">
                  <i className="ri-shield-check-line text-[#D4AF37] text-lg"></i>
                </div>
                <h4 className="text-gray-900 font-semibold text-sm mb-1 leading-snug">100% Originales</h4>
                <p className="text-gray-500 text-xs font-light leading-relaxed">Distribuidores autorizados</p>
              </div>
              <div className="flex flex-col items-start p-5 bg-[#FAF8F5] rounded-2xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/15 rounded-full mb-3">
                  <i className="ri-heart-pulse-line text-[#D4AF37] text-lg"></i>
                </div>
                <h4 className="text-gray-900 font-semibold text-sm mb-1 leading-snug">Hipoalergénico</h4>
                <p className="text-gray-500 text-xs font-light leading-relaxed">Apto para piel sensible</p>
              </div>
            </div>

            <button
              onClick={() => document.getElementById('productos')?.scrollIntoView({ behavior: 'smooth' })}
              className="group px-8 py-4 bg-[#FAF8F5] text-gray-900 text-base font-medium rounded-full hover:bg-[#D4AF37]/20 transition-all flex items-center space-x-3 whitespace-nowrap cursor-pointer"
            >
              <span>Ver Nuestros Productos</span>
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-gray-900 text-lg"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationSection;
